<script setup></script>
<template>
  <div class="flex w-full min-h-svh bg-littleblack">
    <!-- prettier-ignore   -->
    <div class="mx-auto mx-full w-max-[1685px] px-4 sm:px-8 lg:px-16 
    h-full items-center justify-center w-full">
      <div class="text-white">
        <p>HandBox</p>
      </div>
    </div>
  </div>
</template>
